import { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { setAdminSession } from '../lib/supabase'

const SNZ_LOGO = import.meta.env.VITE_SNZ_LOGO_URL || '/api/placeholder/200/80'

export default function AdminLogin() {
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const navigate = useNavigate()
  const location = useLocation()
  const from = location.state?.from || '/admin'

  const handleLogin = () => {
    if (setAdminSession(password)) {
      navigate(from)
    } else {
      setError('Invalid password')
      setPassword('')
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 to-blue-700 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-2xl p-8 w-full max-w-md">
        <div className="flex justify-center mb-6">
          <img src={SNZ_LOGO} alt="Spearfishing New Zealand" className="h-20 object-contain" />
        </div>
        <h1 className="text-3xl font-bold text-blue-900 mb-6 text-center">Admin Login</h1>
        
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {error}
          </div>
        )}
        
        <form onSubmit={e => { e.preventDefault(); handleLogin() }} autoComplete="on" className="space-y-4">
          <input
            type="text"
            name="username"
            autoComplete="username"
            value="snz-admin"
            readOnly
            className="hidden"
            aria-hidden="true"
          />
          <input
            type="password"
            name="password"
            autoComplete="current-password"
            placeholder="Enter admin password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
          />
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition"
          >
            Login
          </button>
          <button
            type="button"
            onClick={() => navigate(from === '/admin' ? '/leaderboard' : from)}
            className="w-full bg-gray-200 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-300 transition"
          >
            Back
          </button>
        </form>
      </div>
    </div>
  )
}
